var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnologyLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 546,
    viewBox: "0 0 545 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M177.469 467.47L188.726 453.157L238.719 389.566L299.968 467.47H177.469Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.31648e-05 406.08H96.5268L96.5337 406.087L48.2737 467.471H48.2599L-6.31648e-05 406.087V406.08Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 389.56L299.982 467.464H299.968L238.719 389.56L238.726 389.553H361.225L361.231 389.56Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.485 468.282L117.263 544.875H237.703L177.485 468.282Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M483.737 233.725L483.744 233.732L422.494 311.636H422.481L361.231 233.732L361.238 233.725H483.737Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 311.636L361.231 233.732L422.48 311.636H299.982Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 311.649L361.238 389.553H361.224L299.975 311.649L299.982 311.636H422.48L422.487 311.649Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 77.9106L422.487 155.815H299.982L361.231 77.9106Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M422.494 155.814H422.487L361.231 77.9106L361.238 77.9038H483.744V77.9106L422.494 155.814Z",
    fill: "black",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 0L483.744 77.9039H361.238L422.487 0Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 466.664L482.72 390.053H362.255L422.487 466.664Z",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M422.494 311.643H544.993L545 311.649L483.751 389.553H483.737H361.238L422.487 311.649L422.494 311.643Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M483.508 233.225L543.976 156.314H422.736L362.267 233.225H483.508Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.732 545.375H238.725H238.732L299.975 467.471L361.224 545.375H238.746H238.732Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 155.814H299.975L238.719 77.9106L238.726 77.9038H361.231V77.9106L299.982 155.814Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.206 390.368L55.9859 466.963H176.427L159.965 446.016L159.965 446.015L116.206 390.368Z",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.383 466.562L177.466 466.668L160.358 445.707L177.133 467.054L177.383 466.562ZM177.383 466.562L160.751 445.398L160.381 445.689L160.751 445.398L116.843 389.561L177.462 312.458L238.082 389.561L188.333 452.842L177.477 466.654L177.392 466.546L177.383 466.562ZM298.951 467.964H178.507L238.732 544.566L298.951 467.964ZM361.231 390.369L300.612 467.472L361.467 544.875H482.708L422.239 467.964H422.238L422.087 467.773L361.231 390.369Z",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 388.753L298.957 312.136H178.481L238.719 388.753Z",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.238 389.553L361.231 389.56L361.225 389.553H361.238Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.601 221.341L192.348 195.582L172.089 221.341H212.601Z",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M308.34 60.8702L275.948 19.6708L243.555 60.8702H308.34Z",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 77.9038H238.726L238.719 77.9102V77.9038Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9497 467.471L54.9428 467.464H54.9565L54.9497 467.471Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.199 389.553H116.213L116.206 389.56L116.199 389.553Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.232 77.9038H361.238L361.232 77.9102V77.9038Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M177.456 311.636H177.469L177.462 311.649L177.456 311.636Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.208 234.225H239.743L299.975 310.835L360.208 234.225Z",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M301.011 156.314L361.238 232.916L421.463 156.314H301.011Z",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 155.814L361.238 233.725H238.698L299.982 155.814Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.258 545.381H361.245L300.002 467.491L300.009 467.477L300.002 467.471H422.501L422.508 467.477L361.258 545.381Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 545.381H238.698L177.463 467.491L177.469 467.477L177.463 467.471H299.955L299.961 467.477L238.719 545.381Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 155.814L238.712 77.9308L238.725 77.9173L238.718 77.9038H361.21L361.217 77.9173L299.982 155.814Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M422.795 311.791H422.782L361.539 233.901L361.546 233.887L361.539 233.874H484.038L484.045 233.887L422.795 311.791Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M116.234 389.546L127.491 375.233L177.483 311.643L238.732 389.546H116.234Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M133.311 411.31L116.206 389.553H238.705L177.456 467.457L133.311 411.31Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219.868 225.121L256.638 271.888V271.894H256.631H183.098L219.868 225.121Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M422.145 467.423L360.916 545.3H422.145V467.423Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyLayer);
export default __webpack_public_path__ + "static/media/technologyLayer.98c1f628eba5f76b21e2bbc68f9dcd15.svg";
export { ForwardRef as ReactComponent };